class PairsWithSlider extends HTMLElement {
  connectedCallback() {
    if (this._initialized) return;
    this._initialized = true;

    const sliderEl = this.querySelector('.pairs-with__products');
    if (!sliderEl) return;

    const wrapperEl = sliderEl.querySelector('.pairs-with__products-wrapper');
    const nextEl = this.querySelector('.pairs-with__button-next');
    const prevEl = this.querySelector('.pairs-with__button-prev');
    const paginationEl = this.querySelector('.pairs-with__pagination');

    const slidesCount = sliderEl.querySelectorAll('.swiper-slide').length;

    // Center only when there is exactly 1 slide.
    if (wrapperEl) {
      wrapperEl.classList.toggle('is-centered', slidesCount === 1);
    }

    if (typeof Swiper === 'undefined') return;
    if (slidesCount < 2) return;

    // eslint-disable-next-line no-new
    new Swiper(sliderEl, {
      slidesPerView: 1.2,
      spaceBetween: 10,
      loop: false,
      speed: 600,
      navigation: nextEl && prevEl ? { nextEl, prevEl } : false,
      pagination: paginationEl ? { el: paginationEl, clickable: true } : false,
      breakpoints: {
        560: {
          slidesPerView: 2.2,
        },
        990: {
          slidesPerView: 3,
        },
      },
    });
  }
}

customElements.define('pairs-with-slider', PairsWithSlider);
